import axios from 'axios';

const URL_API_TWISTERREST = process.env.VUE_APP_URL_API_TWISTER_REST;
const URL_API_INFORME = process.env.VUE_APP_URL_API_INFORMES;

export class InformesApiService {
  getEtiquetas(params) {
    let config = {
      headers: {'Authorization': localStorage.getItem("tokenOauth")}
    };
    const url = `${URL_API_TWISTERREST}informes/etiquetas/`;
    return axios
      .post(url,params,config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }

}